import { Link } from 'react-router-dom';

/**
 * Teaser CTA encouraging signup after seeing projections
 * WP-LANDING-3
 */
export function TeaserCta() {
  return (
    <div className="mt-8 p-6 bg-primary-50 rounded-lg text-center">
      <h3 className="text-lg font-semibold text-primary-900 mb-2">
        Want the full picture?
      </h3>
      <p className="text-primary-700 mb-4 max-w-xl mx-auto">
        This is just a preview. Sign up to personalize for a complete view
        of your financial situation and unique scenarios.
      </p>
      <Link
        to="/register"
        className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg shadow-sm transition-colors"
      >
        Personalize
      </Link>
      <p className="mt-4 text-xs text-primary-600">
        This calculator is for educational purposes only and does not constitute
        financial advice. Please consult a qualified financial advisor for personalized guidance.
      </p>
    </div>
  );
}

export default TeaserCta;
